import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import MenuFooterItem from '../MenuFooterItem';

import SocialLink from './SocialLink';

const FooterSocial = () => {
  const socialLinks = SiteConfigManager.getConfig('config.config.social_links', []);

  if (!socialLinks.length) {
    return null;
  }

  return (
    <MenuFooterItem className="social-links">
      {socialLinks.map(
        socialLink =>
          socialLink.link && <SocialLink key={socialLink.key} socialLink={socialLink} />,
      )}
    </MenuFooterItem>
  );
};

export default FooterSocial;
